import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import DDNJInitiateProposalPageStore, {
  DDNJInitiateProposalPageStoreContext,
  useDDNJInitiateProposalPageStore,
} from 'store/pages/initiate-quote/ddnj/pageStore';
import DDNJBasicInfoStep from 'components/initiate-quote/DDNJ';
import InitiateProposalPageLayout from 'components/common/initiate-proposal/InitiateProposalPageLayout';
import QuoteExperienceStep from 'components/common/initiate-proposal/QuoteExperienceStep';
import FavoriteQuoteStep from 'components/common/initiate-proposal/FavoriteQuoteStep';

const PageContent: React.FC = observer(() => {
  const {
    initiateQuoteFlowDelegate,
    bulletTabsDelegate,
    basicInfoStepController,
    proposalExperienceStepController,
    favoriteProposalStepController,
    proposalExperience,
    getInitialData,
  } = useDDNJInitiateProposalPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <InitiateProposalPageLayout
      initiateQuoteFlowDelegate={initiateQuoteFlowDelegate}
      bulletTabsDelegate={bulletTabsDelegate}
      tabs={[
        <DDNJBasicInfoStep key="0" basicInfoStepController={basicInfoStepController} />,
        <QuoteExperienceStep
          key="1"
          formController={proposalExperienceStepController.form}
          experiences={proposalExperienceStepController.experiences}
          experienceDisabledReasons={proposalExperienceStepController.experienceDisabledReasons}
          experienceAccessLimitations={proposalExperienceStepController.experienceAccessLimitations}
          renewalActionsDelegate={proposalExperienceStepController.renewalActionsDelegate}
        />,
        proposalExperience === 'FAVORITE' && (
          <FavoriteQuoteStep key="2" favoriteProposalStepController={favoriteProposalStepController} />
        ),
      ].filter(Boolean)}
    />
  );
});

const DDNJInitiateProposalPage: React.FC = () => {
  const { groupId } = useParams<{ groupId: string }>();

  const pageStore = useMemo(() => new DDNJInitiateProposalPageStore({ groupId }), [groupId]);

  return (
    <DDNJInitiateProposalPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </DDNJInitiateProposalPageStoreContext.Provider>
  );
};

export default DDNJInitiateProposalPage;
